export default __webpack_public_path__ + "static/media/lipin_w.81b9643d.png";